import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaRecordingTranscriptionStatus } from 'src/app/models/media-recording.model';

@Pipe({
  name: 'mediaRecordingTranscriptionStatusLabel',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class MediaRecordingTranscriptionStatusLabelPipe implements PipeTransform {
  private readonly transcription_status_labels: Record<MediaRecordingTranscriptionStatus, string> = {
    pending: 'Pendiente',
    processing: 'En proceso',
    completed: 'Completada',
    failed: 'Error',
  };

  transform(transcription_status: MediaRecordingTranscriptionStatus | null | undefined): string {
    return this.getMediaRecordingTranscriptionStatusLabel(transcription_status) ?? '';
  }

  private getMediaRecordingTranscriptionStatusLabel(
    transcription_status: MediaRecordingTranscriptionStatus | null | undefined
  ): string | null {
    if (transcription_status === null || transcription_status === undefined) {
      return null;
    }

    return this.transcription_status_labels[transcription_status] ?? transcription_status;
  }
}
